'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPqlFormData = undefined;

var _getScopedProducts = require('ui-addon-upgrades/_core/common/adapters/getScopedProducts');

var _getScopedProducts2 = _interopRequireDefault(_getScopedProducts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getFieldDataFromOptions = function getFieldDataFromOptions(options) {
  var _options$phoneNumberS = options.phoneNumberSubmitted,
      phoneNumberSubmitted = _options$phoneNumberS === undefined ? false : _options$phoneNumberS,
      phoneNumber = options.phoneNumber;


  var fieldData = [{
    name: 'pql_phone_number_submitted',
    value: phoneNumberSubmitted
  }];

  if (phoneNumber) {
    fieldData.push({
      name: 'phone',
      value: phoneNumber
    });
  }

  return fieldData;
};

/**
 * @param {Object}
 * @return {String}
 */
var createPqlFormData = exports.createPqlFormData = function createPqlFormData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      metaData = _ref.metaData,
      upgradeData = _ref.upgradeData,
      user = _ref.user,
      portal = _ref.portal,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options;

  var portalScopes = (0, _getScopedProducts2.default)(portal, user);
  var optionsFieldData = getFieldDataFromOptions(options);
  var bundleUrl = upgradeData.bundleUrl;
  var fieldData = [{
    name: 'email',
    value: user.email
  }, {
    name: 'firstname',
    value: user.first_name
  }, {
    name: 'lastname',
    value: user.last_name
  }, {
    name: 'crm_hub_id',
    value: portal.portal_id
  }, {
    name: 'pql_conversion_date',
    value: metaData.timestamp
  }, {
    name: 'pql_app',
    value: upgradeData.app
  }, {
    name: 'pql_source',
    value: upgradeData.uniqueId
  }, {
    name: 'product_signup',
    value: portalScopes.length > 0 ? portalScopes.join(', ') : ''
  }, {
    name: 'product_upgrade_interest',
    value: upgradeData.campaign || 'General'
  }].concat(_toConsumableArray(optionsFieldData));

  if (bundleUrl) {
    fieldData.push({ name: 'pql_master__c', value: bundleUrl });
  }

  var pqlFormData = {
    submittedAt: metaData.timestamp,
    fields: fieldData,
    skipValidation: true
  };

  return pqlFormData;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/pqlData/createPqlFormData.js
// module id = 531
// module chunks = 3 4 5